import React from 'react';
import {Button, Stack} from "react-bootstrap";
import {Link, useNavigate, useParams} from "react-router-dom";
import {Formik, Form as FormikForm} from "formik";
import {ButtonDelete} from "../../_components";
import {useAlert} from "../../../context";
import {useUser} from "./useUser";
import {isoTimestampToReadableDate} from "../admin/utilities/readableDate";
import {
    ColumnizeText,
    OurClearAlert,
    PageTitle,
    SelectText,
    SingleText,
    SwitchText,
    PasswordButton, AdminUserAlert, TextWithButtonLink
} from "../../_components";

export function AddEditUser() {
    const {uid} = useParams()
    const {success} = useAlert()
    const navigate = useNavigate()

    const {
        value,
        validationSchema,
        addEditItem,
        deleteItem,
        errorValue,
        clearErrorValue,
        role,
        plan
    } = useUser(uid)

    const edit = uid !== "add"

    function handleSubmit(values, actions) {
        addEditItem(values)
            .then(msg => {
                success(msg)
                navigate(-1)
            })
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }

    function handleOnDelete() {
        deleteItem()
            .then(msg => {
                success(msg)
                navigate(-1)
            })
            .catch(console.warn)
    }

    return (
        <>
            <AdminUserAlert/>
            <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

            <PageTitle title="User Details">{edit ? "Edit" : "Add"} user.</PageTitle>

            <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
                {({isSubmitting, resetForm}) => (
                    <FormikForm>

                        <ColumnizeText>
                            <SingleText name="username" tyep="email" label="Email"/>
                            <PasswordButton name="password" label="Password" position="right"/>
                        </ColumnizeText>

                        <SelectText name="role" label="Role" className="mb-2">
                            {role.map(item => (
                                <option key={item.name} value={item.value}>{item.name}</option>
                            ))}</SelectText>

                        <SwitchText name="verified" label="User verification" tip="On for verified user"/>
                        <SwitchText name="active" label="User status" tip="On for user active status"/>

                        <div className="mb-5"/>

                        <ColumnizeText>
                            <SingleText name="first_name" label="First name" maxLength="64"/>
                            <SingleText name="last_name" label="Last name" maxLength="64"/>
                        </ColumnizeText>

                        <SingleText name="location" label="Description" type="textarea"/>

                        <SelectText name="plan" label="Plan" className="mb-2">
                            {plan.map(item => (
                                <option key={item.name} value={item.value}>{item.name}</option>
                            ))}
                        </SelectText>


                        {edit && <>
                            <div className="mb-2 mt-5 fw-semibold fs-5">Additional info</div>
                            <TextWithButtonLink value={value.address_count} label="Saved address" tip="View and manage"
                                                to={`/backend/address/${value.id}`}/>
                            <TextWithButtonLink value={value.order_count} label="Placed orders" tip="View a summary of all orders"
                                                to={`/backend/order/${value.id}`}/>
                            {/*<TextWithButtonLink value={value.product_count} label="Products list" tip="Explore products associated with the user"*/}
                            {/*                    to="/backend/products"/>*/}
                            <TextWithButtonLink value={value.device_count} label="Linked Devices" tip="Check devices linked to the user's account"
                                                to={`/device/${value.id}/list`}/>
                            {/*<TextWithButtonLink value={value.tag_count} label="Linked Tags" tip="Check tags linked to the user's account"*/}
                            {/*                    to={`/device/${value.id}/tags`}/>*/}

                            <div className="mt-5"/>

                            <Stack className="mb-2 text-secondary">
                                <div>
                                    <span className="fw-semibold">Created at</span>
                                    <span>: {value.created_at ? isoTimestampToReadableDate(value.created_at) : "Never"}</span>
                                </div>
                                <div>
                                    <span className="fw-semibold">Verified at </span>
                                    <span>: {value.verified_at ? isoTimestampToReadableDate(value.verified_at) : "Never"}</span>
                                </div>
                                <div>
                                    <span className="fw-semibold">Updated at </span>
                                    <span>: {value.updated_at ? isoTimestampToReadableDate(value.updated_at) : "Never"}</span>
                                </div>
                                <div>
                                    <span className="fw-semibold">Accessed at </span>
                                    <span>: {value.accessed_at ? isoTimestampToReadableDate(value.accessed_at) : "Never"}</span>
                                </div>
                            </Stack>

                        </>}

                        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                            <Button as={Link} variant="link" to={-1}>Go back</Button>
                            <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                            {edit && <ButtonDelete variant="danger" onDelete={handleOnDelete} value={value.name}>Delete</ButtonDelete>}
                            <Button type="submit" variant="success" disabled={isSubmitting}>{edit ? "Edit" : "Add"}</Button>
                        </Stack>
                    </FormikForm>
                )}
            </Formik>
        </>
    )
}
